import React, {useEffect, useMemo} from 'react'
import styled from 'styled-components'

import usePrepareDataForTree from './hooks/usePrepareDataForTree'

import {useCultsStore} from '@pages/CultsPage/store'

import TreeCanvas from './components/TreeCanvas'

import {TREE_BACKGROUND_COLORS, TreeBackgroundColorsEnum} from '@constants/treeBackgroundColors'

const Tree = ({editMode, treeId, tree, persons, readonly = false, initialized = true}) => {
  const {nodes, personsMap} = usePrepareDataForTree(tree.nodes, persons)
  // console.log('### nodes & personsMap', nodes, personsMap)
  const {loadCults} = useCultsStore()

  useEffect(() => {
    loadCults()
  }, [])
  // console.log('### tree', tree)
  const background = useMemo(
    () =>
      tree.background?.url ||
      (tree.background_id < 0
        ? TREE_BACKGROUND_COLORS[tree.background_id].image
        : TREE_BACKGROUND_COLORS[TreeBackgroundColorsEnum.green].image),
    [tree.background?.url, tree.background_id]
  )

  // console.log('### background', background)
  const nonEmptyNodes = useMemo(() => nodes?.length > 0, [nodes])

  return (
    <Wrapper $background={background} $readonly={readonly}>
      {nonEmptyNodes ? (
        <TreeCanvas
          treeId={treeId}
          nodes={nodes}
          personsMap={personsMap}
          editMode={editMode}
          initialized={initialized}
          readonly={readonly}
        />
      ) : null}
    </Wrapper>
  )
}

export default React.memo(Tree)

const Wrapper = styled.div`
  width: 100%;
  height: 100%;

  background-image: url(${({$background}) => $background});
  background-size: cover;
  background-position: center;
  border-radius: ${({$readonly}) => ($readonly ? 0 : 5)}px;

  overflow: hidden;
`
